import React, {Component} from 'react'
import ReactDOM           from 'react-dom'
import classnames         from "classnames"
import interact           from 'interactjs'

import { Icon, message, Spin }  from 'antd'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import CloudFlyerAPI                from '../../api/CloudFlyerAPI'
import { play_file, stop_video } from '../../actions/video-player'


import './styles.scss'

class VideoPlayer extends Component {

  constructor (props) {
    super(props)

    this.state = {
      error             : null,
      play_file_loading : false,
      video_link        : null,
      player:{
        position : { x: 0, y: 0 },
        width : 'auto'
      }
    }
  }

  componentDidMount() {
    this.enable_movable(ReactDOM.findDOMNode(this))
  }

  componentDidUpdate() {
    this.enable_movable(ReactDOM.findDOMNode(this))
  }

  componentWillReceiveProps({Player={}}) {
    if(!Player.cloud_account_id || !Player.bucket_name || !Player.file_name)
      return

    if(Player.playing && (!this.state.video_link || (this.state.cloud_account_id !== Player.cloud_account_id ||
      this.state.bucket_name !== Player.bucket_name ||
      this.state.file_name !== Player.file_name))){
      this.on_play_file(Player.cloud_account_id, Player.bucket_name, Player.file_name)
    }
  }

  on_play_file = (cloud_account_id, bucket_name, file_name)=>{
    let $this = this
    this.setState({
      play_file_loading: true,
      video_link: null
    })

    CloudFlyerAPI
      .transfer
      .download_url(cloud_account_id, bucket_name, [file_name])
      .then(res => {
        $this.setState({play_file_loading: false})
        if(!((res||{}).data||{}) || ((res||{}).data||{}).length === 0){
          return message.error('failed to file, please retry again');
        }
        $this.setState({
          video_link: null,
          cloud_account_id,
          bucket_name,
          file_name
        }, ()=> $this.setState({video_link: (((res||{}).data||{})[0]||{}).url}))
      })
      .catch(err=>
        $this.setState({
          play_file_loading: false,
          video_link: null
        }, () => message.error(err.message)))
  }

  on_play = player =>{
    if(!player)
      player = this.video

    if(!player)
      return

    if (player.paused)
      player.play()
    else
      player.pause()
  }

  on_close = () => this.setState({video_link:null}, this.props.stop_video)

  enable_movable = element =>{
    if(!element)
      return

    //https://stackoverflow.com/questions/3277369/how-to-simulate-a-click-by-using-x-y-coordinates-in-javascript?noredirect=1&lq=1
    interact(element)
      .resizable({
        // resize from all edges and corners
        edges: {
          //left: true,
          right: true,
          bottom: true,
          //top: true
        },

        preserveAspectRatio: true,

        // keep the edges inside the parent
        /*restrictEdges: {
          outer: 'parent',
          endOnly: false
        },*/

        // minimum size
        restrictSize: {
          min: { width: 100, height: 50 },
        },

        inertia: true
      })
      .on('resizemove', event => {
        let target = event.target
        let x      = parseFloat(target.getAttribute('data-x')) || 0
        let y      = parseFloat(target.getAttribute('data-y')) || 0

        // update the element's style
        target.style.width  = event.rect.width + 'px';
        target.style.height = event.rect.height + 'px';

        // translate when resizing from top or left edges
        x += event.deltaRect.left
        y += event.deltaRect.top

        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';

        target.setAttribute('data-x', x)
        target.setAttribute('data-y', y)
      })

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0
    const drag_mouse_down = e => {
      e = e || window.event
      // get the mouse cursor position at startup:
      pos3 = e.clientX
      pos4 = e.clientY
      document.onmouseup = close_drag_element
      // call a function whenever the cursor moves:
      document.onmousemove = drag
    }

    const drag = e => {
      e = e || window.event
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX
      pos2 = pos4 - e.clientY
      pos3 = e.clientX
      pos4 = e.clientY

      // set the element's new position:
      //element.style.bottom = ''
      element.style.top    = (element.offsetTop - pos2) + "px"
      element.style.left   = (element.offsetLeft - pos1) + "px"
    }

    const close_drag_element =()=> {
      /* stop moving when mouse button is released:*/
      document.onmouseup   = null
      document.onmousemove = null
    }

    window.onkeydown = e => {
      if(e.keyCode === 32){ //spacebar
        this.on_play()
      }
    }

    if (this.video_drag) {
      /* if present, the header is where you move the DIV from:*/
      this.video_drag.onmousedown = drag_mouse_down

      /* otherwise, move the DIV from anywhere inside the DIV:*/
      //element.onmousedown = drag_mouse_down
    }
  }

  render() {
    let {
      video_link,
      play_file_loading,
      file_name,
      player={}
    } = this.state

    if (!video_link)
      video_link = this.props.video_link

    const {width} = player

    if(!video_link && !play_file_loading)
      return <div className={'hidden'}/>

    return (
      <div id={'video-container'} className={classnames({'video-container noselect' :true, 'float': this.props.float })}>
        <div className={'player-header draggable video-overlay'} ref={div => this.video_drag = div}>
          <span>{file_name}</span>
          <Icon type="close" onClick={this.on_close}/>
        </div>
        {
          play_file_loading ?
            <Spin spinning={play_file_loading}>
              <video className={'player'}
                     width={width} poster={''}
                     autoPlay controls controlsList="nodownload">
                Your browser does not support HTML5 video
              </video>
            </Spin> :
            <video className={'player'}
                   width={width} poster={''}
                   onClick={e=> this.on_play(e.target)}
                   ref={div => this.video = div}
                   autoPlay controls controlsList="nodownload">
              <source src={video_link} type="video/mp4"/>
              Your browser does not support HTML5 video
            </video>
        }
        <div className={'player-footer'}/>
      </div>
    )
  }
}

export default withRouter(connect(({Player}) => ({Player}),
  (dispatch) => bindActionCreators({play_file, stop_video, dispatch}, dispatch))(VideoPlayer))
